import { Button } from '@otter-ai/den-components';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { PATH_URL } from '@/constants/path-constants';
import { ValidZoomServiceType } from '@/shared/types/auth';
import { useZoomSettings } from '../../hooks/zoom/useZoomSettings';
import { ZOOM_TEST_IDS } from '../../test-ids/zoom';
import { trackZoom } from '../../tracking/zoom-tracking';
import { useCanShowConnectionSettings } from './MoreZoomIntegrations';

/**
 * The settings button to send the user to the Zoom connection settings page.
 */
export function ZoomSettingsButton() {
  const t = useTranslations('settings:integrations.apps.zoom');
  const canShowConnectionSettings = useCanShowConnectionSettings();
  const { serviceSettings } = useZoomSettings();
  if (!canShowConnectionSettings || serviceSettings.length === 0) {
    return null;
  }

  // TODO(OTWEB-9160): Handle multiple accounts
  const path = serviceSettings[0].enabled[ValidZoomServiceType.CLOUD_SYNC]
    ? PATH_URL.ZOOM_CLOUD_SYNC_CONNECTION_SETTINGS
    : PATH_URL.ZOOM_LIVE_NOTES_CONNECTION_SETTINGS;

  // I'm adding the zoomCredentialId for the purpose of troubleshooting
  // since it is possible to have multiple Zoom accounts connected
  const queryParams = new URLSearchParams();
  queryParams.set(
    'zoomCredentialId',
    serviceSettings[0].account.zoom_credential_id.toString(),
  );
  const url = `${path}?${queryParams.toString()}`;

  return (
    <Button
      variant="outlineNeutral"
      version="legacy"
      asChild
      onClick={() => trackZoom.main.gotoZoomConnectionSettings()}
      data-testid={ZOOM_TEST_IDS.manageButton}
    >
      <Link href={url.toString()}>{t('settingsButton')}</Link>
    </Button>
  );
}
